import ShiftDetailsTableMobile from './ShiftDetailsTableMobile'
export default ShiftDetailsTableMobile